import { PHONE_TEL_URL, WHATSAPP_URL } from "@/constants/contact";

export default function CTASection() {
  return (
    <section
      id="cta"
      className="relative py-24 md:py-32 overflow-hidden mb-8 px-4 md:px-8 lg:px-16 max-w-full"
    >
      <div className="absolute inset-0 rounded-3xl overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20dark%20neon%20teal%20wave%20gradient%20futuristic%20technology%20background%20glowing%20particles%20creative%20cinematic&width=1920&height=600&seq=cta-v2&orientation=landscape"
          alt=""
          className="w-full h-full object-cover opacity-50"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-[#030712]/90 via-teal-950/50 to-[#030712]/90" />
        <div className="absolute inset-0 border border-teal-400/20 rounded-3xl" />
      </div>

      <div className="relative z-10 container-main px-4 md:px-8 text-center py-8">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-white mb-4">
          <span className="title-line-1">جاهز تبدأ</span>
          <span className="title-line-2 v2-gradient-text">موقعك الجديد؟</span>
        </h2>
        <p className="text-slate-400 max-w-2xl mx-auto mb-10 text-base md:text-lg">
          احصل على استشارة مجانية من فريق أوامر الشبكة، وسنساعدك في اختيار الحل
          المناسب لنشاطك.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="v2-cta-whatsapp"
          >
            <i className="ri-whatsapp-line text-xl" />
            تواصل عبر واتساب
          </a>
          <a href={PHONE_TEL_URL} className="v2-cta-primary">
            <i className="ri-phone-line" />
            اطلب عرض سعر
          </a>
        </div>
      </div>
    </section>
  );
}
